module.exports = __webpack_public_path__ + "img/integral-item6.7ea4505f.jpg";